"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = exports.Action = exports.defaultLanguages = void 0;
exports.reducer = reducer;
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const GraphQLTypes = __importStar(require("@genesys/graphql-types-tools"));
const constructors_union_1 = require("@genesys/client-core/lib/constructors-union");
exports.defaultLanguages = ["en-GB", "en-US"];
exports.Action = (0, constructors_union_1.ctorsUnion)({
    ProductValidationSetSettings: (settings) => ({ settings }),
    ProductValidationSetValidationProgress: (inProgress, message, current, max) => ({ inProgress, message, current, max }),
    ProductValidationToggleFilter: () => ({}),
    ProductValidationHideFilter: () => ({}),
    ProductValidationSetResult: (messages) => ({
        messages
    }),
    ProductValidationToggleSelectedLanguages: (language) => ({
        language
    }),
    ProductValidationSetShowLanguages: (showLanguagesList) => ({
        showLanguagesList
    }),
    ProductValidationCheckAllLanguages: (languages) => ({
        languages
    }),
    ProductValidationUnCheckAllLanguages: () => ({}),
    ProductValidationCheckDefaultLanguages: () => ({}),
    ProductValidationToggleSelectedVariantDataTables: (variantDataTable) => ({
        variantDataTable
    }),
    ProductValidationToggleShowUndefined: () => ({}),
    ProductValidationSetShowVariantData: (showVariantData) => ({
        showVariantData
    }),
    ProductValidationSetVariantDataFilter: (variantDataTable, filter) => ({
        variantDataTable,
        filter
    }),
    ProductValidationCheckAllVariantDataTables: (variantDataTables) => ({ variantDataTables }),
    ProductValidationUnCheckAllVariantDataTables: () => ({}),
    SetTextIssues: (issues) => ({ issues })
});
exports.initialState = {
    loading: false,
    validationProgress: {
        inProgress: false,
        message: "",
        current: 0,
        max: 0
    },
    filterCollapsed: false,
    showLangugagesList: false,
    showUndefinedVariantDataTables: false,
    showVariantDataList: false,
    settings: {
        systemTypeId: undefined,
        productId: undefined,
        rangeProperties: undefined,
        validateFilterErrors: false,
        validateValueSourceUsage: false,
        validateCalculationMappings: false,
        validateCircularReferences: false,
        validateBillOfMaterial: false,
        billOfMaterialItemNosToValidate: [],
        validateBreakDown: false,
        breakDownItemNosToValidate: [],
        validateOperations: false,
        costOperationNosToValidate: [],
        validatePropertyUsage: false,
        validatePropertyTexts: false,
        languagesToValidate: [],
        validateVariantData: false,
        variantDataTablesToValidate: [],
        errorsOnly: false
    },
    messages: [],
    issues: []
};
// biome-ignore lint: -
function reducer(state = exports.initialState, action) {
    switch (action.type) {
        case "ProductValidationSetSettings": {
            return Object.assign(Object.assign({}, state), { settings: action.settings });
        }
        case "ProductValidationSetValidationProgress": {
            return Object.assign(Object.assign({}, state), { validationProgress: Object.assign(Object.assign({}, state.validationProgress), { inProgress: action.inProgress, message: action.message, current: action.current, max: action.max }) });
        }
        case "ProductValidationToggleFilter": {
            return Object.assign(Object.assign({}, state), { filterCollapsed: !state.filterCollapsed });
        }
        case "ProductValidationSetShowLanguages": {
            return Object.assign(Object.assign({}, state), { showLangugagesList: action.showLanguagesList });
        }
        case "ProductValidationToggleSelectedLanguages": {
            const newState = state.settings.languagesToValidate.some(l => l === action.language)
                ? state.settings.languagesToValidate.filter(l => l !== action.language)
                : state.settings.languagesToValidate.concat(action.language);
            return Object.assign(Object.assign({}, state), { settings: Object.assign(Object.assign({}, state.settings), { languagesToValidate: newState }) });
        }
        case "ProductValidationUnCheckAllLanguages": {
            return Object.assign(Object.assign({}, state), { settings: Object.assign(Object.assign({}, state.settings), { languagesToValidate: [] }) });
        }
        case "ProductValidationCheckAllLanguages": {
            return Object.assign(Object.assign({}, state), { settings: Object.assign(Object.assign({}, state.settings), { languagesToValidate: action.languages }) });
        }
        case "ProductValidationCheckDefaultLanguages": {
            return Object.assign(Object.assign({}, state), { settings: Object.assign(Object.assign({}, state.settings), { languagesToValidate: exports.defaultLanguages }) });
        }
        case "ProductValidationToggleShowUndefined": {
            return Object.assign(Object.assign({}, state), { showUndefinedVariantDataTables: !state.showUndefinedVariantDataTables });
        }
        case "ProductValidationSetShowVariantData": {
            return Object.assign(Object.assign({}, state), { showVariantDataList: action.showVariantData });
        }
        case "ProductValidationHideFilter": {
            return Object.assign(Object.assign({}, state), { filterCollapsed: true });
        }
        case "ProductValidationSetResult": {
            return Object.assign(Object.assign({}, state), { messages: action.messages });
        }
        case "ProductValidationToggleSelectedVariantDataTables": {
            const newState = state.settings.variantDataTablesToValidate.some(vdtv => vdtv.tableName === action.variantDataTable)
                ? state.settings.variantDataTablesToValidate.filter(vdtv => vdtv.tableName !== action.variantDataTable)
                : state.settings.variantDataTablesToValidate.concat({
                    tableName: action.variantDataTable,
                    filter: ""
                });
            return Object.assign(Object.assign({}, state), { settings: Object.assign(Object.assign({}, state.settings), { variantDataTablesToValidate: newState }) });
        }
        case "ProductValidationUnCheckAllVariantDataTables": {
            return Object.assign(Object.assign({}, state), { settings: Object.assign(Object.assign({}, state.settings), { variantDataTablesToValidate: [] }) });
        }
        case "ProductValidationCheckAllVariantDataTables": {
            const previouslyChecked = state.settings.variantDataTablesToValidate;
            const tablesToCheck = action.variantDataTables
                .filter(vdt => vdt.variantDataType !== GraphQLTypes.VariantDataType.UNDEFINED &&
                !previouslyChecked.some(vdtv => vdtv.tableName === vdt.tableName))
                .map(vdt => {
                return {
                    tableName: vdt.tableName,
                    filter: ""
                };
            });
            const newState = previouslyChecked.concat(tablesToCheck);
            return Object.assign(Object.assign({}, state), { settings: Object.assign(Object.assign({}, state.settings), { variantDataTablesToValidate: newState }) });
        }
        case "ProductValidationSetVariantDataFilter": {
            const currentState = state.settings.variantDataTablesToValidate;
            let newState = currentState.filter(vdtv => vdtv.tableName !== action.variantDataTable);
            newState = newState.concat({
                tableName: action.variantDataTable,
                filter: action.filter
            });
            return Object.assign(Object.assign({}, state), { settings: Object.assign(Object.assign({}, state.settings), { variantDataTablesToValidate: newState }) });
        }
        case "SetTextIssues": {
            return Object.assign(Object.assign({}, state), { issues: action.issues });
        }
        default: {
            (0, ts_exhaustive_check_1.exhaustiveCheck)(action);
        }
    }
    return state;
}
//# sourceMappingURL=product-validation-state.js.map